// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a9720b7f","149":"fee4a452"}[chunkId] + ".chunk.js";
};